import { computed, ComputedRef } from 'vue';
import { useAuth, useAuthStore } from '@/composition/use-auth';
import { catalogAccess, ICatalogAccess } from '@/domain/catalog/catalog-access';
import { MemberRole } from '@/interfaces/IMember';
import { useRestaurantStore } from '@/stores/restaurant.store';

/** The current role's capabilities on the Menú page (plan §5.17). */
export function useCatalogAccess(): ComputedRef<ICatalogAccess> {
  const auth = useAuth();
  const authStore = useAuthStore();
  const restaurantStore = useRestaurantStore();

  return computed(() => {
    const role = authStore.currentRole;
    return catalogAccess({
      has: auth.hasPermission,
      tier: restaurantStore.effectiveTier,
      multipleMenus: !!restaurantStore.restaurantSettings?.multipleMenus,
      // The rule `hasRole` applies: staff, owners, and roles over every branch
      // (admin members can be limited to some branches).
      allBranches:
        !!auth.user.value?.admin ||
        role?.type === MemberRole.Owner ||
        !!role?.allBranches,
    });
  });
}
